@use '../../styling/colors.scss' as *;

.PanelCollapseBar {
  position: relative;
  display: grid;
  height: 100%;
  grid-template-rows: 100%;

  .collapseButtonWrapper {
    position: absolute;
    transform: translateX(50%);
    z-index: 1;
    right: 10.5px;
  }

  .emptyChildren {
    width: 21px;
  }

  .overflowWrapper {
    position: relative;

    &.collapsedWrapper {
      max-height: 25px;
      overflow: hidden;
    }
  }
}
